// extracted by mini-css-extract-plugin
module.exports = {"shipping":"ProductShipping_shipping__9g_yR","shippingOptionsButton":"ProductShipping_shippingOptionsButton__fvRFv"};